import { render, staticRenderFns } from "./salesPerformance.vue?vue&type=template&id=c0dc8418&scoped=true"
import script from "./salesPerformance.vue?vue&type=script&lang=js"
export * from "./salesPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dc8418",
  null
  
)

export default component.exports